<!-- FIXME ID This can be simpler, do we use interval, do we select less syncerTypes? Clearify sync with button and text with simple click action -->
<mat-icon class="maticon-button" matTooltip="Sync deze connectie naar staging" (click)="sync()"><span
    class="maticon-button-symbol">cached</span>
</mat-icon>

<!-- <app-button-with-feedback [disabled]="succesfullyPosted && succesfullyPosted.length > 0" (click)="sync()"
  [setup]="syncButton" matTooltip="Sync deze connectie naar staging">
</app-button-with-feedback> -->